/**
 * The "Self-publishing" cluster: book tools that live in different registry categories (converters, text, PDF)
 * but are used together. The tool-page footer links them to each other instead of to unrelated category
 * neighbours. Order is the usual workflow order.
 */
export const SELF_PUBLISHING_IDS = [
  "manuscript-formatter",
  "book-page-estimator",
  "book-interior-maker",
  "low-content-interior-maker",
  "copyright-page-maker",
  "isbn-checker",
  "book-spine-calculator",
  "print-royalty-calculator",
  "kdp-description-formatter",
  "epub-maker",
  "epub-checker",
  "onix-generator",
] as const;

export const SELF_PUBLISHING_LABEL = "Self-publishing tools";

/** The next `count` cluster members after `id`, wrapping around; empty when `id` is not in the cluster. */
export function selfPublishingNeighbours(id: string, count = 4): string[] {
  const list = SELF_PUBLISHING_IDS as readonly string[];
  const i = list.indexOf(id);
  if (i < 0) return [];
  const out: string[] = [];
  for (let k = 1; k < list.length && out.length < count; k++) out.push(list[(i + k) % list.length]);
  return out;
}
